import Env from '../base/env';
import { module as BaseModule } from 'modujs';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
import { SplitText } from '../vendor/gsap-bonus-umd/SplitText';
gsap.registerPlugin(ScrollTrigger,SplitText);

export default class extends BaseModule  {
  constructor(m) {
    super(m);
  }

  init()
  {
    this.DOM = {}
    this.DOM.view = this.el
    this.DOM.fade = this.DOM.view.querySelectorAll('.fxFade')
    this.DOM.fade2 = this.DOM.view.querySelectorAll('.fxFade2')
    this.DOM.text = this.DOM.view.querySelector('.fxText')
    //! FX
    this.FX = {}
    this.FX.text = new SplitText(this.DOM.text,{ type:'lines' })

    //!
    gsap.delayedCall(.4,()=>{
      this.fx()
    })

  }

  fx()
  {
    this.animationReveal()

  }

  animationReveal()
  {
    this.tl = gsap.timeline()

    this.tl
    .add([
      gsap.fromTo(
        this.DOM.fade,
        {
          autoAlpha:0
        },
        {
          autoAlpha:1,
          duration:.6,
          ease:'cubic.out',
          stagger:.3,
        }
      )
    ])
    .add([
      gsap.fromTo(
        this.FX.text.lines,
        {
          autoAlpha:0,
          scaleX:1.2
        },
        {
          autoAlpha:1,
          scaleX:1,
          duration:2,
          ease:'quint.out',
          stagger:.2,
          onStart:()=> gsap.set(this.DOM.text,{autoAlpha:1})
        }
      )
    ],'-=.3')
    .add([
      gsap.fromTo(
        this.DOM.fade2,
        {
          autoAlpha:0,
          y:15
        },
        {
          autoAlpha:1,
          y:0,
          duration:1,
          ease:'cubic.out',
          stagger:.3
        }
      )
    ],'-=1.5')
  }


}
